// PrivacyPolicy.jsx
export default function PrivacyPolicy() {
  return (
    <section className="mx-auto max-w-4xl px-6 py-16">
      <h1 className="text-4xl font-bold mb-6">Privacy Policy</h1>
      <p className="mb-4">
        Your privacy is important to us. This Privacy Policy explains how we
        collect, use, and protect your information when you visit our website.
      </p>
      <h2 className="text-2xl font-semibold mt-6 mb-2">
        Information We Collect
      </h2>
      <p className="mb-4">
        We may collect personal information you provide directly, such as your
        name, email address, or other contact information when you submit forms
        on our website.
      </p>
      <h2 className="text-2xl font-semibold mt-6 mb-2">
        How We Use Your Information
      </h2>
      <p className="mb-4">
        We use your information to provide and improve our services, respond to
        inquiries, and communicate important updates. We will never sell or rent
        your personal information to third parties.
      </p>
      <h2 className="text-2xl font-semibold mt-6 mb-2">Cookies and Tracking</h2>
      <p className="mb-4">
        Our website may use cookies or similar technologies to enhance your
        experience. You can disable cookies in your browser settings if you
        prefer.
      </p>
      <h2 className="text-2xl font-semibold mt-6 mb-2">
        Changes to This Policy
      </h2>
      <p className="mb-4">
        We may update this Privacy Policy from time to time. The latest version
        will always be posted on this page.
      </p>
      <h2 className="text-2xl font-semibold mt-6 mb-2">Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us
        through our website.
      </p>
    </section>
  );
}
